<template>
  <div class="student_detail">
    <p class="detail_title">
      <span>学生</span>
      <span class="title">{{studentData.studentName}}</span>
      <span>详情</span>
    </p>
    <p class="table_caption">关联班级：</p>
    <Table class="relation_klass" size="large" stripe border :columns="relationKlassHeader" :data="studentData.classList">
      <template slot-scope="{row}" slot="schoolName">
        <div class="jump_color" @click="toSchool(row.schoolId)">{{row.schoolName}}</div>
      </template>
      <template slot-scope="{row}" slot="className">
        <div class="jump_color" @click="toClass(row.classId)">{{row.className}}</div>
      </template>
    </Table>
    <p class="table_caption">关联家长：</p>
    <Table class="relation_parents" size="large" stripe border :columns="relationParentsHeader" :data="studentData.parentList">
      <template slot-scope="{row}" slot="phoneTypes">
        <span class="phone_type" v-for="(item,index) in row.phoneTypes">
          <span class="type_num">{{index + 1}},</span>
          {{item}}
        </span>
      </template>
      <template slot-scope="{row}" slot="kind">
        <span>{{row.kind ? '已关注' : '未关注'}}</span>
      </template>
    </Table>
  </div>
</template>
<script>
  import {_getStudentDetail} from '../api/api';
  export default {
    data() {
      return {
        id:'',
        studentData: {},
        relationKlassHeader:[
          {
            title:'地区',
            key: 'region'
          },
          {
            title:'学校',
            key: 'schoolName',
            slot:'schoolName'
          },
          {
            title:'班级',
            key: 'className',
            slot: 'className'
          },
        ],
        relationParentsHeader:[
          {
            key:'userId',
            title: 'ID'
          },
          {
            key:'wxNickname',
            title: '微信昵称'
          },
          {
            key:'kindred',
            title: '关系'
          },
          {
            key:'phone',
            title: '手机号'
          },
          {
            key:"phoneTypes",
            title:"品牌-型号-系统-微信版本",
            slot:"phoneTypes",
            width:700
          },
          {
            key:'kind',
            title: '公众号',
            slot: 'kind'
          },

        ]
      }
    },
    methods: {
//      获取学生详情
      getStudentDetail(){
        const self = this;
        _getStudentDetail(self.id).then(res => {
          if(res.code === 0) {
            if(res.data.parentList && res.data.parentList.length > 0) {
              res.data.parentList.forEach((item,num) =>{
                if(item.phoneTypes) {
                  let tepArr = item.phoneTypes.split('|');
                  tepArr.forEach((list,index) => {
                    if(list.indexOf("undefined") > -1) {
                      tepArr.splice(index,1);
                    }
                  });
                  item.phoneTypes = tepArr;
                }
              })
            }
            self.studentData = res.data;
          }
        })
      },
//      跳转到学校管理
      toSchool(schoolId) {
        this.$router.push(`/schools?id=${schoolId}`)
      },
//      跳转到班级管理
      toClass(classId){
        this.$router.push(`/klasses?id=${classId}`)
      }
    },
    created() {
      this.id = this.$route.query.id;
    },
    mounted() {
      this.getStudentDetail();
    }
  };
</script>
<style scoped>
  .phone_type{
    display:block;
    line-height:20px;
    font-size:14px;
  }
  .type_num{
    font-size: 16px;
    color:#00f;
  }
</style>



// WEBPACK FOOTER //
// src/components/StudentDetail.vue